export default {
  loader: {
    height: '100vh',
    width: '100vw'
  }
}
